// extracted by mini-css-extract-plugin
export var smallCaps = "styles-module--smallCaps--fhinN";
export var altColor = "styles-module--altColor--fzmGs";